import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15fc136f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fc136f')) {
      api.createRecord('15fc136f', component.options)
    } else {
      api.reload('15fc136f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15fc136f&", function () {
      api.rerender('15fc136f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Intention/index.vue"
export default component.exports